<app-full-page-loader></app-full-page-loader>

<section id="main">

  <app-toaster></app-toaster>

  <router-outlet></router-outlet>

</section>